/* eslint-disable @calm/react-intl/missing-formatted-message */

import GridWrapper from '@/components/ui/GridWrapper';
import StarRating from '@/components/ui/StarRating';

import { Heading, HeadingContainer, NumUsers, RatingContainer, User, UserRating, Wrapper } from './styles';

const CalmFeatures = () => {
	return (
		<Wrapper>
			<GridWrapper>
				<HeadingContainer>
					<Heading>Sleep more and stress less with the #1 app for mental health</Heading>
					<UserRating>
						<User $backgroundUrl="/_n/images/jayshetty/star-testimonial-1.webp" />
						<User $backgroundUrl="/_n/images/jayshetty/star-testimonial-2.webp" />
						<User $backgroundUrl="/_n/images//jayshetty/star-testimonial-3.webp" />
						<RatingContainer>
							<StarRating theme="large" />
							<NumUsers>5 Stars from 1.5 million users</NumUsers>
						</RatingContainer>
					</UserRating>
				</HeadingContainer>
			</GridWrapper>
		</Wrapper>
	);
};

export default CalmFeatures;
